import React from "react";
import { observer } from "mobx-react";
import { ProductOrderingListTemplate } from "themes/application/product-ordering/pages";
import { ProductOrderingListViewStore } from "application/product-ordering/stores";
import { setCurrentView } from "core/utils";

@setCurrentView(rootStore => new ProductOrderingListViewStore(rootStore), "productOrderingListViewStore")
@observer
class ProductOrderingList extends React.Component {
	render() {
		return <ProductOrderingListTemplate {...this.props} />;
	}
}

export default ProductOrderingList;